import { useEffect, useState } from 'preact/hooks';
import { Link } from 'preact-router';
import SubmitButton from '../components/ui/SubmitButton';
import useApp from '../context/AppContext';
import { useToaster } from '../context/ToasterContext';
import { nl2br } from '../functions.js';
import { findConfigs, updateConfig } from '../api/api';

export default function Home() {
    const { config, setConfig, checkToken } = useApp();
    const addToast = useToaster();
    const [homeNotes, setHomeNotes] = useState("");
    const [editingNotes, toggleEditingNotes] = useState(false);

    useEffect(() => {
        if (!config) return;
        console.log('home');
        setHomeNotes(config.homeNotes ? JSON.parse(config.homeNotes).notes : "il n'y a pas encore de notes");
    }, [config]);

    const handleSubmitNotes = function (e) {
        e.preventDefault();
        e.returnValue = '';
        const fields = e.target;
        const formNotes = {
            name: 'homeNotes',
            value: JSON.stringify({ date: 0, notes: fields.notes.value }),
        }
        setHomeNotes(fields.notes.value);
        updateConfig(formNotes, 'homeNotes')
            .then(() => {
                addToast('success', 'Notes enregistrées');
                toggleEditingNotes(false);
            })
            .catch((e) => {
                addToast('danger', 'Erreur lors de l\'enregistrement de la note' + e);
            });
    }

    const handleEditingNotes = () => {
        checkToken()
            .then(resp => {
                if (resp) {
                    findConfigs()
                        .then(res => {
                            const config = {}
                            res.map((cfg) => {
                                config[cfg.name] = cfg.value;
                            });
                            setConfig(config);
                        })
                        .catch(err => {
                            addToast('danger', 'Impossible de récupérer les notes : ' + err.message + ' (' + err.cause + ')');
                        })
                }
            })
            .catch(err => {
                addToast('danger', 'Il y a eu une erreur lors de la récupération du jeton : ' + err.message);
            })
        toggleEditingNotes(!editingNotes);
    }

    return (
        <div class="mt-5 home">
            <div class="container mt-5 ms-auto">
                <div class="row row-cols-4">
                    <div class="col">
                        <Link href="/animals">
                            <button type="button" class="btn btn-primary rounded-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-person-add" viewBox="0 0 16 16">
                                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />                       </svg>
                            </button>
                        </Link>
                        <span class="text-center" >Animaux</span>
                    </div>
                    <div class="col">
                        <Link href="/form-animal">
                            <button type="button" class="btn btn-primary rounded-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-person-add" viewBox="0 0 16 16">
                                    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm.5-5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1a.5.5 0 0 1 1 0Zm-1-6a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
                                    <path d="M8.256 14a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Z" />
                                </svg>
                            </button>
                        </Link>
                        <span class="text-center" >Ajouter animal</span>
                    </div>
                    <div class="col">
                        <Link href="/locations">
                            <button type="button" class="btn btn-primary rounded-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-person-add" viewBox="0 0 16 16">
                                    <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM2.04 4.326c.325 1.329 2.532 2.54 3.717 3.19.48.263.793.434.743.484-.08.08-.162.158-.242.234-.416.396-.787.749-.758 1.266.035.634.618.824 1.214 1.017.577.188 1.168.38 1.286.983.082.417-.075.988-.22 1.52-.215.782-.406 1.48.22 1.48 1.5-.5 3.798-3.186 4-5 .138-1.243-2-2-3.5-2.5-.478-.16-.755.081-.99.284-.172.15-.322.279-.51.216-.445-.148-2.5-2-1.5-2.5.78-.39.952-.171 1.227.182.078.099.163.208.273.318.609.304.662-.132.723-.633.039-.322.081-.671.277-.867.434-.434 1.265-.791 2.028-1.12.712-.306 1.365-.587 1.579-.88A7 7 0 1 1 2.04 4.327Z" />
                                </svg>
                            </button>
                        </Link>
                        <span class="text-center" >Sites</span>
                    </div>
                    <div class="col">
                        <Link href="/form-location">
                            <button type="button" class="btn btn-primary rounded-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-person-add" viewBox="0 0 16 16">
                                    <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM2.04 4.326c.325 1.329 2.532 2.54 3.717 3.19.48.263.793.434.743.484-.08.08-.162.158-.242.234-.416.396-.787.749-.758 1.266.035.634.618.824 1.214 1.017.577.188 1.168.38 1.286.983.082.417-.075.988-.22 1.52-.215.782-.406 1.48.22 1.48 1.5-.5 3.798-3.186 4-5 .138-1.243-2-2-3.5-2.5-.478-.16-.755.081-.99.284-.172.15-.322.279-.51.216-.445-.148-2.5-2-1.5-2.5.78-.39.952-.171 1.227.182.078.099.163.208.273.318.609.304.662-.132.723-.633.039-.322.081-.671.277-.867.434-.434 1.265-.791 2.028-1.12.712-.306 1.365-.587 1.579-.88A7 7 0 1 1 2.04 4.327Z" />
                                    <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-3.5-2a.5.5 0 0 0-.5.5v1h-1a.5.5 0 0 0 0 1h1v1a.5.5 0 1 0 1 0v-1h1a.5.5 0 1 0 0-1h-1v-1a.5.5 0 0 0-.5-.5Z" />
                                </svg>
                            </button>
                        </Link>
                        <span class="text-center">Ajouter site</span>
                    </div>
                    <div class="col">
                        <Link href="/history">
                            <button type="button" class="btn btn-primary rounded-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-person-add" viewBox="0 0 16 16">
                                    <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1 .025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z" />
                                    <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z" />
                                    <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z" />
                                </svg>
                            </button>
                        </Link>
                        <span class="text-center">Historique</span>
                    </div>
                    <div class="col">
                        <Link href="/categories">
                            <button type="button" class="btn btn-primary rounded-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-person-add" viewBox="0 0 16 16">
                                    <path d="M3 2v4.586l7 7L14.586 9l-7-7H3zM2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586V2z" />
                                    <path d="M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM1 7.086a1 1 0 0 0 .293.707L8.75 15.25l-.043.043a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 0 7.586V3a1 1 0 0 1 1-1v5.086z" />
                                </svg>
                            </button>
                        </Link>
                        <span class="text-center">Catégories</span>
                    </div>
                    <div class="col">
                        <Link href="/markers">
                            <button type="button" class="btn btn-primary rounded-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-person-add" viewBox="0 0 16 16">
                                    <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                                    <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                </svg>
                            </button>
                        </Link>
                        <span class="text-center">Marqueurs</span>
                    </div>
                    <div class="col">
                        <Link href="/events-type-list">
                            <button type="button" class="btn btn-primary rounded-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-file-earmark-play" viewBox="0 0 16 16">
                                    <path d="M6 6.883v4.234a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.858L6.757 6.454a.5.5 0 0 0-.757.43z" />
                                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                </svg>
                            </button>
                        </Link>
                        <span class="text-center" >Évènements type</span>
                    </div>

                    <div class="col">
                        <Link href="/whowherewhen">
                            <button type="button" class="btn btn-primary rounded-4">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-person-add" viewBox="0 0 16 16">
                                    <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM2.04 4.326c.325 1.329 2.532 2.54 3.717 3.19.48.263.793.434.743.484-.08.08-.162.158-.242.234-.416.396-.787.749-.758 1.266.035.634.618.824 1.214 1.017.577.188 1.168.38 1.286.983.082.417-.075.988-.22 1.52-.215.782-.406 1.48.22 1.48 1.5-.5 3.798-3.186 4-5 .138-1.243-2-2-3.5-2.5-.478-.16-.755.081-.99.284-.172.15-.322.279-.51.216-.445-.148-2.5-2-1.5-2.5.78-.39.952-.171 1.227.182.078.099.163.208.273.318.609.304.662-.132.723-.633.039-.322.081-.671.277-.867.434-.434 1.265-.791 2.028-1.12.712-.306 1.365-.587 1.579-.88A7 7 0 1 1 2.04 4.327Z" />
                                </svg>
                            </button>
                        </Link>
                        <span class="text-center" >Qui était où ?</span>
                    </div>
                </div>
                {config && config['instanceName'] && <div class="instanceName">{config['instanceName']}</div>}
                {editingNotes ?
                    <form onSubmit={(handleSubmitNotes)}>
                        <div class="form-floating mt-3 mb-3">
                            <textarea class="form-control" id="notes" name="notes" style="height: auto" rows="15" >{homeNotes ? homeNotes : "Chargement des notes..."}</textarea>
                            <label class="form-label" for="notes">Notes</label>
                        </div>
                        <SubmitButton label="Enregistrer les notes" />
                    </form>
                    :
                    <div class="lh-1 mt-3 mb-3 p-3 rounded-4 w-100 overflow-hidden" style="background-color:#ffc107" onclick={handleEditingNotes}>
                        {homeNotes ? nl2br(homeNotes) : "Chargement des notes..."}
                    </div>
                }
            </div>
        </div>
    );
}